import { FilterUpdateAction, Filters, Actions } from 'modules/Documents/FiltersContext/Filters.interface';

export const initialState: Filters = {
    member_uuid: '',
    isEmployeeView: true,
    isTabFilterActive: false,
    product_categories: ['all'],
    page_size: 10,
    page: 0,
    is_deleted: false,
    is_internal: [false, true],
    file_name: '',
    document_type: [],
    year: 'all',
    uuid: '',
    quarter: ['Q1', 'Q2', 'Q3', 'Q4'],
    month: 'all',
    created_at: 'all',
    audit: '',
    sort: {
        by: 'created_at',
        order: 'desc',
    },
    isSearchActive: false,
};

export const reducer = (state: Filters, action: { type: string; payload: FilterUpdateAction }) => {
    switch (action.type) {
        case 'RESET_FILTERS':
            return { ...initialState };
        case 'UPDATE_FILTERS':
            return { ...state, ...action.payload };
        default:
            return { ...state };
    }
};

export const actions: Actions = {
    resetFilters: () => ({ type: 'RESET_FILTERS' }),
    updateFilters: (payload: FilterUpdateAction) => ({ type: 'UPDATE_FILTERS', payload }),
};
